import styled from 'styled-components/macro';

export const DateDiv = styled.div`
  width: 100%;

  & .react-datepicker {
    width: 100%;
    border-color: rgba(0, 0, 0, 0.15) !important;

    & .react-datepicker__month-container {
      width: 100%;

      & .react-datepicker__header {
        border-color: rgba(0, 0, 0, 0.15) !important;
      }

      & .react-datepicker__day-names,
      & .react-datepicker__week {
        display: flex;
        justify-content: space-evenly;

        & .react-datepicker__day--selected {
          background-color: ${({ themeColor }) => themeColor}!important;
           &:focus {
            outline-color: transparent!important;
          }
        }
      }
    }
  }
`;
